import { lazy } from 'react'
import { Building2, Users } from 'lucide-react'
import type { FeatureRoute, NavItem } from '@/features/types'

const Contacts = lazy(() => import('@/features/contacts/pages/Contacts').then((m) => ({ default: m.Contacts })))
const ContactDetail = lazy(() => import('@/features/contacts/pages/ContactDetail').then((m) => ({ default: m.ContactDetail })))
const Clients = lazy(() => import('@/features/contacts/pages/Clients').then((m) => ({ default: m.Clients })))
const ClientDetail = lazy(() => import('@/features/contacts/pages/ClientDetail').then((m) => ({ default: m.ClientDetail })))

export const contactsRoutes: FeatureRoute[] = [
  { path: 'contacts', element: <Contacts /> },
  { path: 'contacts/:id', element: <ContactDetail /> },
  { path: 'sales/clients', element: <Clients /> },
  { path: 'clients/:id', element: <ClientDetail /> },
]

export const contactsNav: NavItem[] = [
  { to: '/sales/clients', label: 'Client info', icon: Building2, section: 'Sales' },
  { to: '/contacts', label: 'Contacts', icon: Users, section: 'Sales' },
]
